// extracted by mini-css-extract-plugin
export default {"container":"Vj-z","blurb":"Wj-z","links":"Xj-z"};